module.exports = __webpack_public_path__ + "img/checkmark.d378c1f7.svg";